module.exports = __webpack_public_path__ + "img/ELSYS_ELT2.860e552b.webp";